import { apiClient, signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";

export const getSignStatus = async ({
  id,
  credentials,
}: {
  id: string;
  credentials: unknown;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/auth/auth?id=${id}`,
    credentials,
    { "content-type": "application/json" }
  );

  const response = await apiClient({
    url: signedRequest.endpoint,
    method: "GET",
    headers: signedRequest?.options?.headers,
  });
  return response.data;
};

export const useGetSignStatus = ({
  id,
  enabled,
  credentials,
}: {
  id: string;
  enabled: boolean;
  credentials: unknown;
}) => {
  const signStatusQuery = useQuery({
    queryKey: ["get-sign-status"],
    queryFn: () => getSignStatus({ id, credentials }),
    retry: false,
    refetchInterval: 1500,
    enabled: enabled,
    staleTime: Infinity,
  });
  return signStatusQuery;
};
